import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Box, Typography, Grid, Button, useTheme } from "@mui/material";
import { get_posts_public } from "../../Redux/Actions/action";
import { showLoader } from "../../Redux/Slices/loaderSlice";

export default function PPSKEvents() {
    const limit = 9;
    const bucketUrl = 'https://webitodevelopment.s3.ap-south-1.amazonaws.com/';
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();

    const [heroEventData, setHeroEventData] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const fetchData = async (pageNum) => {
        try {
            dispatch(showLoader(true));
            const res = await dispatch(get_posts_public({
                type: 'News-Events',
                status: 'Active',
                page: pageNum,
                limit: limit
            }));

            const newData = res?.payload?.data?.data || [];
            const count = res?.payload?.data?.count || 0;

            setHeroEventData((prev) => {
                const updatedData = [...prev, ...newData];
                if (updatedData.length >= count) {
                    setHasMore(false);
                }
                return updatedData;
            });
            dispatch(showLoader(false));
        } catch (err) {
            console.error('Error:', err);
            dispatch(showLoader(false));
        } finally {
        }
    };

    useEffect(() => {
        fetchData(page);
    }, [page]);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Container sx={{ mt: { lg: '60px', md: '60px', sm: "40px", xs: '20px' } }}>
                <Typography
                    color={"primary"}
                    sx={{
                        fontSize: { lg: "44px", md: "30px", sm: "26px", xs: "20px" },
                        fontWeight: "bold",
                        marginBottom: { lg: "40px", md: "30px", sm: "26px", xs: "20px" },
                        textAlign: 'center'
                    }}
                >
                    PPSK Events
                </Typography>
                <Grid container spacing={2}>
                    {heroEventData.map((event, i) => {
                        const details = event.eventDetails;
                        return (
                            <Grid item xs={12} sm={6} md={4} lg={4} key={i}>
                                <Box
                                    component="img"
                                    src={bucketUrl + details?.bannerImage}
                                    alt={details?.eventName || 'Event'}
                                    sx={{
                                        width: '100%',
                                        borderRadius: 2,
                                        mb: 2,
                                        margin: '0px',
                                    }}
                                />
                                <Box
                                    sx={{
                                        paddingTop: '12px',
                                        display: 'flex',
                                        gap: { lg: '24px', sx: "12px" },
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        fontWeight={600}
                                        sx={{ fontSize: { lg: "22px", md: "20px", sm: "16px", xs: "16px" } }}
                                    >
                                        {details?.eventName || 'Untitled Event'}
                                    </Typography>

                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        mb={1}
                                        sx={{ fontSize: { lg: "14px", md: "14px", sm: "14px", xs: "14px" } }}
                                    >
                                        {details?.date ? new Date(details.date).toLocaleDateString('en-IN', {
                                            day: 'numeric',
                                            month: 'short',
                                            year: 'numeric'
                                        }) : ''}{" "}
                                        {details?.time ? `| ${details.time}` : ''}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    mb={1}
                                    sx={{
                                        // margin: '12px',
                                        fontSize: { lg: "16px", md: "16px", sm: "14px", xs: "14px" },
                                        overflow: "hidden",
                                        display: "-webkit-box",
                                        WebkitBoxOrient: "vertical",
                                        WebkitLineClamp: "none",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {details?.description || ''}
                                </Typography>
                                <Button
                                    sx={{
                                        fontWeight: 600,
                                        padding: '0px',
                                        marginBottom: '24px',
                                        fontSize: { lg: "18px", md: "16px", sm: "14px", xs: "14px" },
                                        textTransform: "none",
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                    onClick={() => navigate(`/event/${event._id}`)}
                                >
                                    View More
                                </Button>
                            </Grid>
                        );
                    })}
                </Grid>
                {hasMore && heroEventData?.length > 0 && (
                    <Box textAlign={"center"} sx={{ marginTop: { lg: "40px", sm: '24px' }, marginBottom: { lg: "50px", sm: '24px' } }}>
                        <Button
                            sx={{
                                width: '158px',
                                padding: '6px 24px',
                                borderRadius: '10px',
                                backgroundColor: theme.palette.primary.main,
                                color: 'white',
                                fontSize: '18px',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: theme.palette.primary.main,
                                }
                            }}
                            onClick={() => setPage(prev => prev + 1)}
                        >
                            Load More
                        </Button>
                    </Box>)}
            </Container>
        </>
    );
}
